import { sendJoinWorkspaceEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class JoinWorkspaceEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendJoinWorkspaceEvent;
  protected intercomEventKey = 'join_workspace';

  constructor(settings: { workspace_id: string; join_method?: 'code' | 'link'; }) {
    super();

    try {
      this.eventData = settings;
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
